export const OPTIMIZATION_TYPES = {
  from_storehouse: "со склада",
  to_storehouse: "на склад",
};
